export const CONST_COLLECTION = 'collection';
export const CONST_COLLECTIONS = 'collections';
export const CONST_PAYEE = 'payee';
export const CONST_PAYEES = 'payees';
export const CONST_PICK_A_DATE = 'Pick a date';
export const CONST_AFTER_NUMBER_TIMES = 'After a number of times';
export const CONST_WHEN_I_CANCEL = 'When I Cancel';
export const CONST_ON_DATE = 'on-date';
export const CONST_ON_NUMBER = 'on-number';
export const CONST_ON_CANCEL = 'on-cancel';

export const CONST_INSTRUCTED = 'INSTRUCTED';
export const CONST_GBP_EQUIVALENT = 'GBP_EQUIVALENT';
export const CONST_EQUIVALENT = 'EQUIVALENT';
export const CONST_AMOUNT_UPPERCASE = 'AMOUNT';
export const CONST_HARD = 'HARD';
export const CONST_THIRDPARTY = 'THIRDPARTY';
export const CONST_SOFT = 'SOFT';
export const CONST_REMITTANCE = 'REMITTANCE_AMOUNT';

export const CONST_FILE_UPLOAD = {
	BENEFICIARY: 'fileUpload.beneficiary',
	BACS_CREDIT: 'fileUpload.bacsCredit',
	BACS_DEBIT: 'fileUpload.bacsDebit',
	FPS: 'fileUpload.fps',
	CHAPS: 'fileUpload.chaps',
	MAX_ITEMS_PER_CHUNK_BENEFICIARY: 'fileUpload.chunks.maxItemsPerChunk.beneficiary',
	MAX_ITEMS_PER_CHUNK_FPS: 'fileUpload.chunks.maxItemsPerChunk.fps',
	MAX_ITEMS_PER_CHUNK_CHAPS: 'fileUpload.chunks.maxItemsPerChunk.chaps',
	MAX_ITEMS_PER_CHUNK_SCHEDULED_PAYMENTS: 'fileUpload.chunks.maxItemsPerChunk.scheduledPayments',
	MAX_THREADS: 'fileUpload.chunks.maxThreads',
	BATCH_TYPE: 'Upload',
	CLIENT_SIDE_ERROR: {
		BACS: 'frontEndErrorBacsPayment',
		FPS: 'frontEndErrorFPSPayment',
		EMPTY_FILE: 'frontEndEmptyFileError',
		DEFAULT: 'frontEndError',
	},
	UNKNOWN: 'unknown',
};
